// extracted by mini-css-extract-plugin
export default {"zone":"styles_zone__URjrK"};